var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{class:_vm.rating >= 0 ? '' : 'spinAnimation',attrs:{"large":"","color":_vm.getColor(_vm.rating)},domProps:{"textContent":_vm._s(_vm.rating >= 0 ?("mdi-numeric-" + _vm.rating + "-circle") : 'mdi-saw-blade')}})}
var staticRenderFns = []

export { render, staticRenderFns }